export class ImageUtils {
  public static relocateImage(imageUrl: string): string {
    if (!imageUrl || imageUrl.startsWith('http')) {
      return imageUrl;
    }
    // Remove the doubles in some urls
    const temp = imageUrl.replace('//', '/').replace('./assets/', '/assets/');
    const result = this.getCloudURL() + temp;

    return result;
  }

  public static getCloudURL(): string {
    // return 'https://storage.cloud.google.com/kickthe';
    return 'https://storage.googleapis.com/kickthe';
  }
}
